import request from '@/service/index'
import postJson from "@/service/postJson"
import http from "../service";
//获取店铺详情
export const qryShopDetail = (shopId) => {
    return request({
        url: `shop/shopInfo/${shopId}/info`,
        method: 'get'
    })
}

//修改店铺信息
export const saveShopInfo = (data) => {
    return postJson({
        url: 'shop/shopInfo/updateSetting',
        method: 'post',
        data,
        headers:{'Content-Type': 'application/json' }
    })
}

//修改店铺信息
export const qryShopInfoCount = (params) => {
    return request({
        url: 'statistic/shopStatistic/queryShopInfoCount',
        method: 'get',
        params,
    })
}


//获取柜子所在小区信息
export const qryShopInGroup = (params) => {
    return request({
        url: 'agent/agentAuthOrg/qryAgentAuthOrgByShopId',
        method: 'get',
        params,
    })
}


//确认异常
export const confirmWarning = (params) => {
    return request({
        url: 'shop/shopInfo/confirm',
        method: 'get',
        params,
    })
}

/**
 * 重启设备
 */
export const  restartShop = (params) => {
    return request({
        url: 'shop/shopInfo/restartShop',
        method: 'get',
        params
    })
}
/**
 * 重启广告
 */
export const  restartAdvert = (params) => {
    return request({
        url: 'shop/shopInfo/restartAdvert',
        method: 'get',
        params
    })
}

/**
 * 获取分组
 */
export const  getNearestquarter = (params) => {
    return request({
        url: 'agent/agentAuthOrg/selectDistanceNearestOrg',
        method: 'get',
        params
    })
}

export const clearZoneWay = (params) => {
    // return postJson({
    //     url: 'shop/shopZoneWay/clearZoneWay',
    //     method: 'post',
    //     data,
    //     headers:{'Content-Type': 'application/json' }
    // })
    return request({
        url: 'shop/shopZoneWay/clearZoneWay',
        method: 'get',
        params
    })

}
/**
 * 获取分组设备统计
 */
export const  getOrgShopCount = (params) => {
    return request({
        url: 'shop/shopZoneWay/queryZoneWayUse',
        method: 'get',
        params
    })
}
/**
 * 获取分组内设备列表
 */
export const  getOrgShopList = (params) => {
    return request({
        url: 'shop/shopZoneWay/pageQueryZoneWayUse',
        method: 'get',
        params
    })
}

/**
 * 柜子货道关联订单
 */
export const  bindZoneWayToOrder = (params) => {
    return request({
        url: 'shop/shopZoneWay/bindingZoneWayOrder',
        method: 'get',
        params
    })
}

/**
 * 柜子货道重新关联订单
 */
export const  reBindZoneWayToOrder = (params) => {
    return request({
        url: 'shop/shopZoneWay/rebindingZoneWayOrder',
        method: 'get',
        params
    })
}

/**
 * 配送员开寄存柜货道
 */
export const  openShopZoneWay = (params) => {
    return request({
        url: 'shop/shopInfo/openDoorForPostman',
        method: 'GET',
        params,
        // headers:{'Content-Type': 'application/json' }
    })
}

/**
 * 配送员取出货道订单
 */
export const  cancelBindOrder = (params) => {
    return request({
        url: 'shop/shopZoneWay/cancelBindingZoneWayOrder',
        method: 'GET',
        params,
    })
}

/**
 * 柜子货道取消关联订单
 */
export const  cancelBindOrderV3 = (data) => {
    return postJson({
        url: 'shop/shopZoneWay/cancelBindingZoneWayOrderV3',
        method: 'post',
        data,
    })
}


/**
 * 请求上传开门视频or关门视频
 */
export const uploadDoorVideo = (data) => {
    return request({
        url: 'shop/doorLockLog/reqUploadDoorLogFile',
        data,
        method: 'post',
    })
}
/**
 * 获取开关门详情
 */
export const getDoorLockLogDetail = (data) => {
    return request({
        url: 'shop/doorLockLog/getDoorLockLogVo',
        data,
        method: 'post',
    })
}

/**
 * 查询设备库区商品列表
 */
export const  queryShopZoneWayItemList = (params) => {
    return request({
        url: 'shop/shopZone/queryShopZoneWayItemList',
        method: 'GET',
        params,
    })
}

/**
 * 称重柜去皮
 */
export const  clearWeight = (params) => {
    return request({
        url: 'shop/shopInfo/clearWeightForAdmin',
        method: 'GET',
        params,
    })
}

//修改商家信息
export const saveMallShopInfo = (data) => {
    return request({
        url: 'shop/shopInfo/save',
        method: 'post',
        data,
    })
}


export const queryMyShop = (params) => {
    return request({
        url: 'shop/shopInfo/selectMyShop',
        method: 'get',
        params,
    })
}
//商家核销订单
export const checkOrder = (params) => {
    return request({
        url: 'order/orderBase/checkVirtualOrder',
        method: 'get',
        params,
    })
}


//获取小区列表
export const qryOrgList = (params) => {
    return request({
        url: 'agent/agentAuthOrg/selectDistanceNearestOrg',
        method: 'get',
        params,
    })
}


//根据货道编码查询关联订单信息
export const qryWayOrderInfoByWayId = (params) => {
    return request({
        url: 'order/orderBase/qryWayOrderInfoByWayId',
        method: 'get',
        params,
    })
}

//根据设备编码查询货道信息
export const qryShopWayInfoByShopId = (params) => {
    return request({
        url: 'shop/shopZoneWay/qryShopInfoByShopId',
        method: 'get',
        params,
    })
}


/**
 * 补货端开门
 */
export const  openDoorForAdmin = (data) => {
    return request({
        url: 'shop/shopInfo/openDoorForAdmin',
        method: 'post',
        data,
    })
}



/**
 * 寄存柜开门
 */
export const  openDoorForLocker = (data) => {
    return postJson({
        url: 'shop/shopInfo/openDoorForLocker',
        method: 'post',
        data
    })
}

/**
 * 寄存柜货道关联订单
 */
export const  bindingZoneWayOrder2 = (data) => {
    return postJson({
        url: 'shop/shopZoneWay/bindingZoneWayOrder2',
        method: 'post',
        data
    })
}
/**
 * 多用户-寄存柜货道关联订单
 */
export const  bindingZoneWayOrder3 = (data) => {
    return postJson({
        url: 'shop/shopZoneWay/bindingZoneWayOrderV3',
        method: 'post',
        data
    })
}

/**
 * 多用户-寄存柜货道关联订单
 */
export const  selectAllOrg = (data,parentId) => {
    if(parentId == null){
        parentId = '636617153931378688'
    }
    return request({
        url: 'agent/agentAuthOrg/select?agentId='+data+"&parentId="+parentId,
        method: 'get'
    })
}

/**
 * 下发更新价签显示指令
 */
export const  updateShopPriceShow = (params) => {
    return request({
        url: 'shop/shopInfo/updateShopPriceShow',
        method: 'get',
        params
    })
}

export const  syncShopItemStock = (params) => {
    return request({
        url: 'shop/deviceInfo/syncShopItemStock',
        method: 'get',
        params
    })
}
//查询设备的商品分类列表
export const getDeviceProductCategory = params => {
    return request({
        url: 'item/shopItemStock/qryShopCategoryByShopItemStock',
        method: 'get',
        params
    })

};

//获取商品列表
export const getProductList = params => {
    return request({
        url: 'item/shopItem',
        method: 'get',
        params
    })

};



export const getLastHeartbeat = (params) => http.get("/shop/shopHeartbeat/getLastHeartbeat", { params });

export const getShopDeviceVersion = (params) => http.get("/shop/shopDeviceVersion/getById", { params });



export const listShopDeviceVersion = (params) => http.get("/shop/shopDeviceVersion/list", { params });



// WEBPACK FOOTER //
// ./src/api/shop.js